// Default pagination values
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

// Common sort fields
export const EMPLOYEE_SORT_FIELDS = [
  'employeeNumber',
  'legalLastName',
  'legalFirstName',
  'workEmail',
  'hireDate',
  'jobTitle',
  'status',
  'createdAt',
  'updatedAt',
] as const;

export const DEPARTMENT_SORT_FIELDS = [
  'code',
  'name',
  'status',
  'createdAt',
  'updatedAt',
] as const;

export const LOCATION_SORT_FIELDS = [
  'code',
  'name',
  'city',
  'country',
  'status',
  'createdAt',
  'updatedAt',
] as const;

export const JOB_SORT_FIELDS = [
  'code',
  'title',
  'jobLevel',
  'status',
  'createdAt',
  'updatedAt',
] as const;
